import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

const useGetLoginUrl = () => {
  const location = useLocation();
  const unifiedLoginUrl = useSelector((state) => state?.app?.unifiedLoginUrl);
  const unifiedLoginUrlFormatted = new URL(unifiedLoginUrl);
  if (typeof window !== 'undefined') {
    unifiedLoginUrlFormatted.searchParams.set(
      'returnUri',
      `${window.location.protocol}//${window.location.host}${window.location.pathname}${location.search}`
    );
  }
  return unifiedLoginUrlFormatted.toString();
};

export default useGetLoginUrl;
